/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetCaseResourcesByIds$Params {
  ignoreEndDate?: boolean;
      body: Array<number>
}

export function getCaseResourcesByIds(http: HttpClient, rootUrl: string, params: GetCaseResourcesByIds$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: CaseResourceDto;
}>> {
  const rb = new RequestBuilder(rootUrl, getCaseResourcesByIds.PATH, 'post');
  if (params) {
    rb.query('ignoreEndDate', params.ignoreEndDate, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: CaseResourceDto;
      }>;
    })
  );
}

getCaseResourcesByIds.PATH = '/case-resources/list';
